var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`hint-box ${_vm.type}`},[_c('i',{staticClass:"material-icons"},[_vm._v("star")]),_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }